import { z } from 'zod';
import { RoleSchema } from './role.schema.js';
/**
 * Membership = a User's role in an Organisation.
 *
 * Invariants (enforced in the Membership aggregate on the backend):
 *   - Unique by (userId, organisationId): a User has at most one role per Org.
 *   - An Organisation must have at least one `tenant_admin` at all times.
 *     Removing the last admin throws IdentityError.lastAdminCannotLeave().
 *
 * Super admins (Swoft staff) do NOT have Memberships.
 */
export const MembershipSchema = z.object({
    id: z.string(),
    userId: z.string(),
    organisationId: z.string(),
    role: RoleSchema,
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
/**
 * Light DTO used by the frontend switcher & permission hooks.
 * Embeds the Organisation name to avoid an extra round-trip.
 */
export const MembershipSummarySchema = z.object({
    id: z.string(),
    organisationId: z.string(),
    organisationName: z.string(),
    role: RoleSchema,
});
export const InviteMemberInputSchema = z.object({
    email: z.string().email(),
    role: RoleSchema,
});
export const ChangeMemberRoleInputSchema = z.object({
    role: RoleSchema,
});
//# sourceMappingURL=membership.schema.js.map